import { Button, ButtonProps, styled } from '@quillbot/design-system';
import PremiumIconSvg from 'src/_common/quillElements/icon/PremiumIcon';
import { NativePlatform } from 'core/models/platform';
import { useSelector } from 'react-redux';
import { useRouter } from 'next/router';
import QuillLocalStorage from 'core/utils/localStorageClient';
import { RootState } from 'src/_common/models/redux/store';
import { useEffect } from 'react';

const StyledPremiumButton = styled(Button)`
  && {
    font-weight: 700;
    margin-right: 10px;
    // width: 150px;
    // width: 155px;
    text-align: center;
    padding: 6px;
    margin: 0;
    border-radius: 20px;
    white-space: nowrap;
  }
`;

interface IProps extends ButtonProps {
  referrer?: string;
  text?: string;
  native?: NativePlatform | null;
  close?: Function | null;
  bgColor?: 'primary' | 'secondary';
}

const PremiumButton = (props: IProps) => {
  const isSubscriptionPaused = useSelector((state: RootState) => state.user?.isSubPaused);
  const router = useRouter();
  const LOCAL_STORAGE = QuillLocalStorage.getInstance();
  useEffect(() => {
    LOCAL_STORAGE.set('upgradeVisitedFrom', router.pathname);
  }, []);

  return (
    <StyledPremiumButton
      className="no-box-shadow"
      variant="contained"
      color={props.bgColor ? props.bgColor : 'primary'}
      onClick={() => {
        if (isSubscriptionPaused) {
          window.open(`/settings${props.native ? `?native=${props.native}` : ''}`);
        } else {
          window.open(
            `/premium?referrer=${props.referrer}${props.native ? `&native=${props.native}` : ''}`
          );
        }
        if (props.close) props.close();
      }}
      {...props}
    >
      <PremiumIconSvg
        transparent
        style={{
          width: 18,
          height: 20,
          marginRight: 8,
        }}
      />
      {props.text || 'Get Premium'}
    </StyledPremiumButton>
  );
};

export default PremiumButton;
